import Questions from "components/Questions/Questions";


const QuestionsPage: React.FC = () => {
  return <Questions />;
};

export default QuestionsPage;
